import * as types from "../Actions/actionTypes";

import { MentorAccess, MentorData } from "../../sharedTypes";
import { DateTime } from "luxon";

export const mentorInitialState = {
    mentorAccess: null as any,
} as MentorData;

export default function mentorAccessReducer(state = mentorInitialState.mentorAccess, action: any): MentorAccess {
    switch (action.type) {
        case types.MENTOR_TOKEN_REFRESH_NEEDED:
            return {
                token: localStorage.getItem("token"),
                expiration: DateTime.fromISO(
                    localStorage.getItem("expiration") ?? DateTime.utc().plus({ minutes: 30 }).toISO()
                ),
            } as MentorAccess;
        case types.MENTOR_TOKEN_EXPIRED:
            localStorage.setItem("token", "");
            return { ...state, expiration: state.expiration };
        case types.MENTOR_TOKEN_REFRESHED:
            var token = action.newToken.token;
            var tokenExpiration = action.newToken.expiration;
            localStorage.setItem("token", token);
            localStorage.setItem("expiration", tokenExpiration);
            return { token: token, expiration: DateTime.fromISO(tokenExpiration) } as MentorAccess;
        default:
            if (!state) {
                return {
                    token: localStorage.getItem("token"),
                    expiration: DateTime.fromISO(
                        localStorage.getItem("expiration") ?? DateTime.utc().plus({ minutes: 30 }).toISO()
                    ),
                } as MentorAccess;
            }
    }

    return state;
}
